import React, { useEffect } from 'react';
import Tooltip, { Overlay } from '@components/Tooltip';
import { Section, SettingsSectionBox, SettingsSectionLabel } from '@views/Settings/components';
import styles from './ClayProfile.module.scss';
import ContactHeader from '@components/Contact/Header';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContact, selectContact } from '@actions/contacts';
import analytics from '@support/analytics';
import { useNavigate } from 'react-router-dom';
import { PenIcon, ClayProfileIcon } from '@components/Icons';
import { closeSettings } from '@actions/ui';
import { ID } from '@app/types';

export default function ClayProfile({ contactID }: { contactID: ID }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userProfile = useSelector(selectContact(contactID));

  const editProfile = () => {
    analytics.track('Profile Edited');
    dispatch(closeSettings);
    navigate(`/contact/self/form`);
  };

  const viewProfile = () => {
    analytics.track('Profile Viewed');
    dispatch(closeSettings);
    navigate(`/contact/${contactID}`);
  };

  useEffect(() => {
    dispatch(fetchContact({ id: contactID }));
  }, []);

  return (
    <>
      <Section>
        <SettingsSectionLabel>Your Profile</SettingsSectionLabel>
        <SettingsSectionBox className={styles.box}>
          <ContactHeader className={styles.preview} contact={userProfile} sidebar />
          <div className={styles.buttons}>
            <Tooltip placement="bottom" overlay={<Overlay>View Profile</Overlay>}>
              <ClayProfileIcon onClick={viewProfile} />
            </Tooltip>
            <Tooltip placement="bottom" overlay={<Overlay>Edit Profile</Overlay>}>
              <PenIcon className={styles.btn} onClick={editProfile} />
            </Tooltip>
          </div>
        </SettingsSectionBox>
      </Section>
    </>
  );
}
